
import ChannelList from "@/components/chat/ChannelList.vue";
import ThreadInfo from "@/components/chat/ThreadInfo.vue";
import Threads from "@/components/chat/Threads.vue";
import UserList from "@/components/chat/UserList.vue";
import { ChatState } from "@/utils/chat-state";
import Vue from "vue";
import { checkHasModule } from "../../router";
import { MODULE } from "../../config/modules";

export default Vue.extend({
	data() {
		return {
			state: new ChatState()
		};
	},
	watch: {
		$route: {
			immediate: true,
			handler() {

				if (this.$router.currentRoute.fullPath != "/chat") {
					this.state.settings.LastVisitedPath = this.$router.currentRoute.fullPath;
				} else {
					this.$router.push(this.state.settings.LastVisitedPath.toString());
				}


				let params = this.$route.params;
				let threadId = parseInt(params.threadId || "0");
				this.state.fetchThread(threadId);
			}
		},
		"state.settings": {
			deep: true,
			handler() {
				this.state.saveSettings();
			}
		}
	},
	methods: {
		async refresh() {

		}
	},
	async created() {
		if (!checkHasModule(MODULE.CHAT, this.$router)){
			throw new Error("MISSING MODULE");
		}
		await this.state.fetchSettings();
		await this.state.fetchConversations();
		await this.state.fetchUnreads();
		this.$router.push(this.state.settings.LastVisitedPath.toString());
	},
	components: {
		UserList,
		ChannelList,
		Threads,
		ThreadInfo
	},
	i18nEx: {
		componentPrefix: "views.ChatRoute"
	}
});
